import { useNavigate } from "react-router-dom";
import { route } from "../../../shim/jsbridge";

export const useSampleSummaryNavigation = (useLegacyNavigate = false) => {
  const navigate = useNavigate();

  const navigateToSampleSummary = (hash: string) => {
    const sampleDetailsRoute = route("redirect_samples_details", {
      hash_value: hash
    });

    if (useLegacyNavigate) {
      window.location.href = sampleDetailsRoute;
      return;
    }

    navigate(sampleDetailsRoute);
  };

  return { navigateToSampleSummary };
};
